module.exports = __webpack_public_path__ + "static/media/bannerYT2.456b40b7.png";